/**
 * Used to enrich errors.
 */
export const MODULE_NAME = 'global scripts';
